import { useCart } from '../context/CartContext';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const CartSidebar = () => {
  const { cart, isCartOpen, closeCart, openModal, updateQuantity, removeFromCart } = useCart();
  const [loadingId, setLoadingId] = useState<number | null>(null);
  const { t, i18n } = useTranslation();

  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  return (
    <div
      className={`fixed top-0 right-0 h-full w-80 bg-white shadow-2xl z-50 transform transition-transform duration-300 ${isCartOpen ? 'translate-x-0' : 'translate-x-full'}`}
      style={{ maxWidth: '90vw' }}
      dir={i18n.language === 'he' ? 'rtl' : 'ltr'}
    >
      <div className="flex justify-between items-center p-4 border-b">
        <h2 className="text-xl font-bold">{t('cart.title', 'הסל שלי')}</h2>
        <button onClick={closeCart} className="text-2xl font-bold">×</button>
      </div>
      <div className="p-4 flex-1 overflow-y-auto" style={{ minHeight: 200 }}>
        {cart.length === 0 ? (
          <div className="text-gray-500 text-center mt-8">{t('cart.empty', 'הסל ריק')}</div>
        ) : (
          cart.map((item) => (
            <div key={item.id} className="flex items-center justify-between py-2 border-b">
              <div className="flex items-center gap-2">
                <img src={item.image} alt={item.name} className="w-12 h-12 object-cover rounded" />
                <div>
                  <div className="font-semibold">{item.name}</div>
                  <div className="text-sm text-gray-500">₪{item.price}</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  className="px-2 py-1 bg-gray-200 rounded"
                  onClick={async () => {
                    setLoadingId(item.id);
                    await updateQuantity(item.id, item.quantity - 1);
                    setLoadingId(null);
                  }}
                  aria-label={t('cart.decrease', 'Decrease quantity')}
                  disabled={loadingId === item.id}
                >
                  -
                </button>
                <span className="px-2">{item.quantity}</span>
                <button
                  className="px-2 py-1 bg-gray-200 rounded"
                  onClick={async () => {
                    setLoadingId(item.id);
                    await updateQuantity(item.id, item.quantity + 1);
                    setLoadingId(null);
                  }}
                  aria-label={t('cart.increase', 'Increase quantity')}
                  disabled={loadingId === item.id}
                >
                  +
                </button>
                <button
                  className="ml-2 text-red-500 hover:text-red-700"
                  onClick={async () => {
                    setLoadingId(item.id);
                    await removeFromCart(item.id);
                    setLoadingId(null);
                  }}
                  aria-label={t('cart.remove', 'Remove item')}
                  title={t('cart.remove', 'Remove item')}
                  disabled={loadingId === item.id}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                    <path fillRule="evenodd" d="M6 8a1 1 0 012 0v5a1 1 0 11-2 0V8zm4 0a1 1 0 012 0v5a1 1 0 11-2 0V8z" clipRule="evenodd" />
                    <path d="M4 6a1 1 0 011-1h10a1 1 0 011 1v10a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm2-3a1 1 0 00-1 1v1h10V4a1 1 0 00-1-1H6z" />
                  </svg>
                </button>
              </div>
            </div>
          ))
        )}
      </div>
      <div className="p-4 border-t">
        <div className="flex justify-between items-center mb-2 text-lg font-bold">
          <span>{t('cart.total', 'סך הכל')}:</span>
          <span>₪{total.toLocaleString()}</span>
        </div>
        <button
          className="w-full bg-blue-500 text-white py-3 rounded-lg font-bold hover:bg-blue-600 transition mb-2 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={openModal}
          disabled={cart.length === 0}
        >
          {t('cart.checkout', 'לרכישה')}
        </button>
      </div>
    </div>
  );
};

export default CartSidebar; 